import React, { useState } from "react"
import styled from "styled-components"
import fonts from "../../../styles/fonts"
import colors from "../../../styles/colors"
import { withTranslation } from "gatsby-plugin-react-i18next"
import Field from "./Field"
import { Fields, Intro, SubmitButton, Title } from "./Styles"
import { resetPassword } from "../../../services/user/user"
import { LOGIN_FORM } from "../../../context/form/formTypes"

const StyledForm = styled.form`
  margin-top: -4px;
`

const StyledTitle = styled(Title)`
  margin-bottom: 26px;
  text-align: center;
`
const StyledIntro = styled(Intro)`
  margin: 0 auto 40px;
  text-align: center;
  max-width: 380px;
  padding-bottom: 2px;
`

const ErrorMessage = styled(StyledIntro)`
  color: #db3232;
  margin-top: -30px;

`

const FieldContainer = styled.div`
  padding-top: ${props => props.first ? "0" : "40px"};
`

const StyledSubmitButton = styled(SubmitButton)`
  margin: 40px 0 0;
`

const PasswordLink = styled.div`
  ${fonts.helveticaNeue};
  color: ${colors.grey};
  font-size: 8px;
  line-height: 1.25;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 4px;
  button {
    cursor: pointer;
    background: transparent;
    ${fonts.helveticaNeue};
    color: ${colors.grey};
    font-size: 8px;
    line-height: 1.25;
    text-align: right;
    padding: 0;
    border: none;
    text-decoration: underline;
  }
`

const ResetPassword = ({ t, resetPasswordToken, setContent }) => {
  const [formData, setFormData] = useState({
    password: "",
    password2: "",
  })
  const [errors, setErrors] = useState({
    password: "",
    password2: "",
  })

  const [submitError, setSumbitError] = useState(false)

  const handleChange = (name, value) => {
    let updatedFormData = formData
    updatedFormData[name] = value
    setFormData(updatedFormData)
  }

  const validateForm = () => {

    let hasError = false
    const formFields = Object.keys(formData)
    const updatedErrors = {
      password: "",
      password2: "",
    }

    formFields.forEach((formField) => {

      const regex = /^(?=\S*[A-Z])(?=\S*[^\w\s])\S{8,}$/;
      const isCorrect = regex.test(formData[formField])

      if(!isCorrect && formData[formField].length > 0 ) {
        updatedErrors[formField] = t("account.form_password_format_error")
        hasError = true;
      }
      if (formData[formField].length === 0) {
        updatedErrors[formField] = t("account.form_empty_field_error")
        hasError = true;
      }
    })

    if (formData["password"] !== formData["password2"]) {
      if(formData["password2"].length > 0) {
        updatedErrors["password2"] = t("account.form_different_passwords_error")
        hasError = true;
      }
    }

    setErrors(updatedErrors)
    return hasError
  }

  const submitForm = async (e) => {
    e.preventDefault()
    setSumbitError(false)

    const hasError = validateForm();

    if (hasError) {
      return
    }

    try {
      await resetPassword(resetPasswordToken, formData.password)
      setContent(LOGIN_FORM)
    } catch (error) {
      console.error(error)
      setSumbitError(true)
    }
  }

  const switchToLogin = (e) => {
    e.preventDefault()
    setContent(LOGIN_FORM)
  }

  return (
    <StyledForm onSubmit={submitForm}>
      <StyledTitle>{t("account.reset_password_title")}</StyledTitle>
      <StyledIntro>{t("account.reset_password_intro")}</StyledIntro>
      {submitError && (
        <ErrorMessage>{t("account.form_submit_error")}</ErrorMessage>
      )}
      <Fields>
        <FieldContainer first>
          <Field
            data={formData}
            name="password"
            placeholder={t("account.form_choose_new_password_placeholder")}
            handleChange={handleChange}
            type="password"
            error={errors.password}
            isPopup
          />
        </FieldContainer>
        <FieldContainer>
          <Field
            data={formData}
            name="password2"
            placeholder={t("account.form_choose_new_password_placeholder")}
            handleChange={handleChange}
            type="password"
            error={errors.password2}
            isPopup
          />
        </FieldContainer>
      </Fields>
      <StyledSubmitButton type="submit">
        {t("account.reset_password_title")}
      </StyledSubmitButton>
      <PasswordLink  i18nKey={"remember_password_link"}>
        You remember your password? No problem, <button type="button" onClick={switchToLogin}>sign up here as usual</button>
      </PasswordLink>
    </StyledForm>
  )
}

export default withTranslation()(ResetPassword)
